module.exports = __webpack_public_path__ + "static/media/IMG_20190616_125308.5937c6e7.jpg";